import { booleanAttribute } from "#ce/utils/props";
export const props = Object.freeze({
  /**
   * The ID of the event.
   * @type {Number}
   */
  eventId: {
    type: [Number, String],
    required: true,
  },
  /**
   * URL to POST preview data to.
   * @type {String}
   */
  previewUrl: {
    type: String,
    required: true,
  },
  /**
   * URL to POST confirmed registrants to.
   * @type {String}
   */
  processUrl: {
    type: String,
    required: true,
  },
  /**
   * Whether the modal should auto-open on mount.
   * @type {Boolean|String}
   */
  autoOpen: booleanAttribute(),
  /**
   * The label used for the entity being invited (e.g., "Attendee" or "Registration").
   * Passed from the server to support I18n.
   * @type {String}
   */
  label: {
    type: String,
    default: "Attendee",
  },
  /**
   * Label for the email input field.
   * @type {String}
   */
  emailInputLabel: {
    type: String,
    default: "Type or paste email addresses",
  },
  /**
   * HTML content for the dropzone instruction text.
   * @type {String}
   */
  dropzoneText: {
    type: String,
    default: "Drag and drop spreadsheet here, or <strong>click to browse</strong>",
  },
  /**
   * Server-rendered HTML for the file specification panel.
   * @type {String}
   */
  fileSpecHtml: {
    type: String,
    default: "",
  },
  /**
   * URL to the "Add single attendee" form. When set, a link is shown
   * in the input step that closes the modal and opens the new-action-modal.
   * @type {String}
   */
  addAttendeeUrl: {
    type: String,
    default: "",
  },
  /**
   * JSON object of localized UI copy, passed by the helper and deep-merged over
   * English defaults in the store, which owns the default. Shape (camelCase keys):
   * `{dropzone: {remove, viewSpec, hideSpec}, selection: {selectAll, includeRow, selectedCount}}`;
   * `selection.includeRow` uses `%{name}`, `selection.selectedCount` uses `%{count}` and `%{total}`.
   * @type {String}
   */
  labels: {
    type: String,
  },
});
